import { Component, input, Input } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { SearchResult } from '../../../../../shared/services/responses/platform/search.response';
import { Router } from '@angular/router';
import { LoadingBoxComponent } from "../../../../../shared/components/loading-box/loading-box.component";
import { BookVersionViewService } from '../../../../../shared/services/apis/platform/book-version-view.service';
import { UtilService } from '../../../../../shared/services/util.service';


// Interface estendida para incluir dados mocados necessários para a UI que não vêm da API
export interface BookUIData extends SearchResult {
  coverImage: string;
}

@Component({
  selector: 'app-book',
  standalone: true,
  imports: [CommonModule, CurrencyPipe, LoadingBoxComponent],
  templateUrl: './book.component.html',
  styleUrls: ['./book.component.css'],
  host: { ngSkipHydration: 'true' }
})
export class BookComponent {

  constructor(private router: Router,
    private bookVersionViewService: BookVersionViewService,
    public utilService: UtilService) {

  }

  // A anotação @Input() permite que o componente pai (search-list) passe os dados do livro.
  @Input() bookData: BookUIData | null;
  @Input() searchTerm: string;

  /**
   * Retorna um array de booleans para renderizar as estrelas de avaliação.
   * Ex: rating = 4, retorna [true, true, true, true, false]
   */
  get stars(): boolean[] {
    return Array.from({ length: 5 }, (_, index) => index < (this.bookData != null ? this.bookData.rating : 0));
  }

  // Retorna o primeiro autor da lista para exibição.
  get mainAuthor(): string {
    if (this.bookData?.autores && this.bookData.autores.length > 0) {
      return this.bookData.autores.join(', ');
    }
    return 'Autor desconhecido';
  }

  redirect() {
    if (this.bookData == null) return;

    if (this.bookData.idBookVersion) {
      this.bookVersionViewService.RegisterView(this.bookData.idBookVersion)
        .subscribe({
          error: () => { } // silencioso
        });
    }

    this.router.navigate([`/livro/${this.bookData.idKit}/${this.utilService.createSlug(this.bookData.bookTitle ?? 'livro')}`], { queryParams: { termo: this.searchTerm } });
  }
}